import type {IconType} from 'src/common/Icon'
import {IconBadge} from './IconBadge'

export type FlowStep = {
  icon: IconType
  label: string
}

export type FlowDiagramProps = {
  steps: FlowStep[]
}

const FlowConnector = () => (
  <span className="mt-[22px] flex items-center gap-1" aria-hidden="true">
    <span className="size-1 rounded-full bg-green-neon/70" />
    <span className="size-1 rounded-full bg-green-neon/70" />
    <span className="size-1 rounded-full bg-green-neon/70" />
  </span>
)

export const FlowDiagram = ({steps}: FlowDiagramProps) => (
  <div className="flex flex-wrap items-start justify-center gap-5 py-8">
    {steps.map((step, stepIndex) => (
      <div key={stepIndex} className="flex items-start gap-5">
        <div className="flex flex-col items-center gap-2 text-center">
          <IconBadge icon={step.icon} size="m" />
          <span className="text-12 text-green-mist-dim">{step.label}</span>
        </div>
        {stepIndex < steps.length - 1 && <FlowConnector />}
      </div>
    ))}
  </div>
)
